import React from 'react';
import '../about/about.css';
import './misija.css';
import missionMedia from '../../assets/mockup/mission_media.jpg';
import { useTranslation } from 'react-i18next';

function Misija() {
  const { t } = useTranslation('global');
  return (
    <section
      className="band-section band-section--photo band-section--end"
      aria-labelledby="mission-title"
      style={{ '--band-photo': `url(${missionMedia})` }}
    >
      <div className="band-section__photo" aria-hidden="true" />
      <div className="band-section__grid bm-container">
        <div className="glass-panel glass-panel--on-photo glass-panel--edge-right">
          <h2 id="mission-title">{t('mission.our_mission')}</h2>
          <p className="glass-panel__brand">BeoMedica</p>
          <div className="glass-panel__body">
            <p>{t('mission.paragraph_1')}</p>
            <p>{t('mission.paragraph_2')}</p>
            <p>{t('mission.paragraph_3')}</p>
          </div>
        </div>
        <div className="band-media band-media--right band-media--spacer" aria-hidden="true" />
      </div>
    </section>
  );
}

export default Misija;
